import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import getLang from 'academy-common-lib/utils/getLang';
import useNavigate from 'academy-common-lib/hooks/useNavigate';
const MY_PLAYLISTS_URL_FRAGMENT = '/saved-items/playlists';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { useCreatePlaylist } from '../savedItemsQueries';
import { PlaylistForm } from './PlaylistForm';
import { AddItemToPlaylistSuccessNotification } from './AddItemToPlaylistButton';
import { jsx as _jsx } from "react/jsx-runtime";
const VALID_PLAYLIST_ITEM_TYPES = ['TRACK', 'LESSON', 'SHORT_FORM_CONTENT'];
const normalizeItemToAdd = itemToAdd => {
  var _itemToAdd$language;
  if (!itemToAdd) return null;
  if ('itemId' in itemToAdd) return itemToAdd;
  const language = convertToSupportedLanguage((_itemToAdd$language = itemToAdd.language) !== null && _itemToAdd$language !== void 0 ? _itemToAdd$language : getLang());
  const type = VALID_PLAYLIST_ITEM_TYPES.find(t => t === itemToAdd.type);
  if (!type) return null;
  return {
    itemId: itemToAdd.id,
    language,
    type
  };
};
const CreatePlaylistModal = ({
  itemToAdd: itemToAddProp,
  onRequestClose
}) => {
  const navigate = useNavigate();
  const itemToAdd = normalizeItemToAdd(itemToAddProp);
  const {
    createPlaylist,
    createPlaylistError,
    createPlaylistLoading
  } = useCreatePlaylist({
    onCompleted(playlist) {
      UsageTracker.trackStandalone('Playlist Interaction', {
        action: 'playlist-created',
        location: itemToAdd ? 'create-playlist-modal-add-item' : 'create-playlist-modal'
      });
      if (itemToAdd) {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(AddItemToPlaylistSuccessNotification, {
            item: {
              id: itemToAdd.itemId,
              language: readUnhandledEnumCase(itemToAdd.language).toLowerCase(),
              type: itemToAdd.type
            },
            playlistId: playlist.id,
            playlistName: playlist.name
          }),
          type: 'success'
        });
        onRequestClose();
        return;
      }
      navigate(`${MY_PLAYLISTS_URL_FRAGMENT}/${playlist.id}`);
      onRequestClose();
    }
  });
  const onSubmit = values => {
    createPlaylist(Object.assign({}, values, {
      items: itemToAdd ? [itemToAdd] : []
    })).catch(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('academyCommon.savedItems.tooltips.savePlaylistError'),
        type: 'danger'
      });
    });
  };
  const onCancel = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'close-create-modal'
    });
  };
  return /*#__PURE__*/_jsx(PlaylistForm, {
    error: createPlaylistError,
    formLoadedMarker: null,
    initialValues: {
      name: '',
      description: ''
    },
    loading: createPlaylistLoading,
    onCancel: onCancel,
    onRequestClose: onRequestClose,
    onSubmit: onSubmit,
    submitButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.common.create"
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlists.createPlaylist"
    })
  });
};
export default CreatePlaylistModal;